import React from 'react';

export default function ProcessList() {
  return (
    <va-process-list>
      <va-process-list-item header="Check your eligibility">
        <p>
          You’ll need to apply and be found eligible for the VA education
          benefit under which you want your reimbursement processed.
        </p>
      </va-process-list-item>
      <va-process-list-item header="Gather your information">
        <h4>Here’s what you’ll need to fill out this form:</h4>
        <ul>
          <li>Your current mailing address and contact information</li>
          <li>The name of the national exam you took</li>
          <li>
            The name and address of organization issuing the national exam (must
            be a US-based organization)
          </li>
          <li>A receipt showing that you have paid in full</li>
          <li>A copy of your exam results</li>
        </ul>
      </va-process-list-item>
      <va-process-list-item header="Fill out the online form">
        <p>
          We’ll take you through each step of the process. It should take about
          15 minutes. You’ll also be provided the opportunity to give additional
          commentary regarding your exam.
        </p>
      </va-process-list-item>
      <va-process-list-item header="Submit the online form">
        <p>
          Your completed form will submit automatically once you are done
          filling out information about your exam and uploading your supporting
          documents.
        </p>
      </va-process-list-item>
    </va-process-list>
  );
}
